import {Injectable} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {map, of} from 'rxjs';
import * as countries from 'i18n-iso-countries';

/**
 * ISO 3166-1 standard;
 * Property 'id' is an alpha3 country code.
 * Umpire countries list has expanded ISO standard to include Countries of the United Kingdom
 */
@Injectable()
export class CountriesService {
  readonly countriesOfUnitedKingdom = of([
    {
      id: 'ENG',
      name: 'libs.core.countries.england',
    },
    {
      id: 'SCT',
      name: 'libs.core.countries.scotland',
    },
    {
      id: 'WLS',
      name: 'libs.core.countries.wales',
    },
    {
      id: 'NIR',
      name: 'libs.core.countries.northernIreland',
    },
  ]).pipe(
    map(countries =>
      countries.map(country => ({
        id: country.id,
        name: this.translatePipe.transform(country.name),
      })),
    ),
  );

  readonly countries$ = this.countriesOfUnitedKingdom.pipe(
    map(countriesOfUnitedKingdom =>
      Object.entries(
        countries.getNames(this.translateService.currentLang, {select: 'official'}),
      )
        .map(([key, value]) => ({
          id: countries.alpha2ToAlpha3(key) as string,
          name: value as unknown as string,
        }))
        .map(country => {
          // Kosovo is assigned a wrong code in the iso-countries library, should be XKX not XKK
          if (country.id === 'XKK') {
            return {
              id: 'XKX',
              name: country.name,
            };
          }
          return country;
        })
        .concat(countriesOfUnitedKingdom)
        .sort((a, b) => a.name.localeCompare(b.name)),
    ),
  );

  constructor(
    readonly translateService: TranslateService,
    readonly translatePipe: TranslatePipe,
  ) {}
}
